<!-- This card is only for uploading tool images, not other image content -->
<template>
  <v-card color="primary" class="ma-auto" outlined max-width="500">
    <v-card-title class="white--text"
      >Cancelling Registration<v-spacer />
      <v-btn
        class="mx-2"
        text
        fab
        dark
        small
        @click.stop="showHelp()"
        v-if="!$vuetify.breakpoint.mdAndUp"
      >
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </v-card-title>

    <v-list class="py-0" :disabled="isBusy">
      <v-list-item class="py-2">
        Click here to cancel your registration
      </v-list-item>  
      <v-list-item>
        <v-btn color="secondary" large class="mr-3" @click="sendCancel">
          <v-icon class="mr-2">mdi-cancel</v-icon>Cancel
        </v-btn>
      </v-list-item>
      <v-list-item>
        Wait, I changed my mind...
        <v-btn color="primary" large class="mr-3" @click="goBack">
          <v-icon class="mr-2">mdi-arrow-left</v-icon>Back to signup
        </v-btn>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import HelpDialog from "@/support/helpMessage";
import dataloader from "@/api/dataloader.js";

export default {
  data: () => ({
    isBusy: false,
  }),
  props: {
    username: {
      type: String,
      required: false,
      default: "",
    },
    accesscode: {
      type: String,
      required: false,
      default: "",
    },
  },

  computed: {},

  methods: {
    async showHelp() {
      const aMessage = HelpDialog.GetHelpMessage();
      await this.$root.$confirmdialog("About - Fab.nano Signup", aMessage, {
        color: "secondary",
        reject: "",
        accept: "Okay",
      });
    },
    goBack() {
      this.$router.push("/");
    },
    async sendCancel() {
      this.isBusy = true;
      await dataloader.sendCancellationUsingAccessCode(this.username, this.accesscode);
      this.isBusy = false;
      this.$store.dispatch("getData");
      this.$router.push("/");
    },
  },

  mounted() {},
};
</script>
